import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2StatsResponse {
  admin_count: number,
  super_admin_count: number,
  operator_count: number
}

export class AgentV2StatsData {
  @Required("admin_count cannot be empty")
  @IsNumber("admin_count must be a number")
  adminCount: number;

  @Required("super_admin_count cannot be empty")
  @IsNumber("super_admin_count must be a number")
  superAdminCount: number;
  
  @Required("operator_count cannot be empty")
  @IsNumber("operator_count must be a number")
  operatorCount: number;
}

const transformAndValidateData = (
  response: AgentV2StatsResponse
): AgentV2StatsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2StatsData);
  } catch (error) {
    console.error("Agent v2 stats data validation failed:", error.message);
    throw error;
  }
};

/** 权限管理-agent聚合统计(管理员总数/超级管理员/运行人员) */
export const agentV2Stats = async (agentId: string) => {
  const res = await api.post<AgentV2StatsResponse>('/agent-v2/stats', {
    agent_id: agentId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}